<main class="main c21">
    <div>
        <article class="card box">
            <h2>Esquema de colores</h2>
            <div class="col row " style="min-height: 60px">
                <div class="col btn-verde-oscuro">Verde-oscuro</div>
                <div class="col btn-primary">Primary</div>
                <div class="col btn-verde-issys" >verde-issys / success</div>
                <div class="col btn-secondary">Secondary</div>
                <div class="col btn-warning">Warning</div>
                <div class="col btn-danger">Danger</div>
                <div class="col btn-dark">Dark</div>
                <div class="col btn-ligth">Ligth</div>
            </div>
        </article>
        <article class="card box">
            <h2>Esquema Secundario/análogo</h2>
            <div class="col row " style="min-height: 60px">
                <div class="col btn-azul-oscuro">Azul-oscuro</div>
                <div class="col btn-azul">Azul</div>
                <div class="col btn-azul-issys">azul-issys</div>
                <div class="col btn-celeste">celeste</div>
                <div class="col btn-naranja">naranja</div>
                <div class="col btn-ocre">ocre</div>
                <div class="col btn-tea">tea</div>
                <div class="col btn-verde-claro">Verde claro</div>
                <div class="col btn-gris-claro">Gris Claro</div>
            </div>
        </article>
        <article class="card box">
            <h3>Combinaciones de colores</h3>
            <table style="text-align: center;">
                <tr>
                    <th style="text-align: left;">Background</th>
                    <td class="badge-azul-oscuro" style="width: 15%">Azul-oscuro</td>
                    <td class="badge-verde-oscuro" style="width: 15%">Vere-oscuro</td>
                    <td class="badge-primary" style="width: 15%">primary</td>
                    <td class="badge-azul" style="width: 15%;">azul</td>
                    <td class="badge-gris-claro" style="width: 22%">gris-claro</td>
                    <td class="badge-ligth" style="width: 22%">Ligth</td>
                </tr>
                <tr>
                    <th style="width: 110px; text-align: left;">Títulos</th>
                    <td colspan="4" ><div >Titulo:white</div><div class="badge-gris-claro">Subtitulo:gris-claro</div></td>
                    <td colspan="2" ><div class="badge-primary">Titulo:Primary</div><div class="badge-secondary">Subtitulo:Secondary</div></td>
                </tr>
                <tr>
                    <th style="width: 110px; text-align: left;">Texto</th>
                    <td colspan="4" >White</td>
                    <td colspan="2" class="badge-dark">Dark</td>
                </tr>
                <tr>
                    <th style="width: 110px; text-align: left;">Enlace</th>
                    <td colspan="2" class="badge-ocre">ocre</td>
                    <td class="badge-celeste">celeste</td>
                    <td class="badge-tea">tea</td>
                    <td class="badge-azul-issys">azul-issys</td>
                    <td class="badge-verde-issys">verde-issys</td>
                </tr>
                <tr>
                    <th style="width: 110px; text-align: left;">Enlace</th>
                    <td colspan="2" class="badge-naranja">naranja</td>
                    <td colspan="2" class="badge-ocre">ocre</td>
                    <td class="badge-verde-issys">verde-issys</td>
                    <td class="badge-azul-issys">azul-issys</td>
                </tr>
                <tr>
                    <th style="width: 110px; text-align: left;">Resaltado</th>
                    <td colspan="2" class="badge-celeste">celeste</td>
                    <td colspan="2" class="badge-verde-claro">verde-claro</td>
                    <td class="badge-success">Texto: success</td>
                    <td class="badge-verde-claro">Back: verde-claro</td>
                </tr>
            </table>
        </article>
    </div>
    <div class="card box">
        <h4>#TAG's</h4>
        <div class="col row gap-10">
            <p class="col-8 tag tag-1">#tag-1</p><p class="col tag mark tag-1">+ mark</p>
        </div>
        <div class="col row gap-10">
            <p class="col-8 tag tag-2">#tag-2</p><p class="col tag mark tag-2">+ mark</p>
        </div>
        <div class="col row gap-10">
            <p class="col-8 tag tag-3">#tag-3</p><p class="col tag mark tag-3">+ mark</p>
        </div>
        <div class="col row gap-10">
            <p class="col-8 tag tag-4">#tag-4</p><p class="col tag mark tag-4">+ mark</p>
        </div>
        <div class="col row gap-10">
            <p class="col-8 tag tag-5">#tag-5</p><p class="col tag mark tag-5">+ mark</p>
        </div>
        <div class="col row gap-10">
            <p class="col-8 tag tag-6">#tag-6</p><p class="col tag mark tag-6">+ mark</p>
        </div>
        <div class="col row gap-10">
            <p class="col-8 tag tag-7">#tag-7</p><p class="col tag mark tag-7">+ mark</p>
        </div>
        <div class="col row gap-10">
            <p class="col-8 tag tag-8">#tag-8</p><p class="col tag mark tag-8">+ mark</p>
        </div>
        <div class="col row gap-10">
            <p class="col-8 tag tag-9">#tag-9</p><p class="col tag mark tag-9">+ mark</p>
        </div>
        <div class="col row gap-10">
            <p class="col-8 tag tag-10">#tag-10</p><p class="col tag mark tag-10">+ mark</p>
        </div>
        <div class="col row gap-10">
            <p class="col-8 tag tag-11">#tag-11</p><p class="col tag mark tag-11">+ mark</p>
        </div>
        <div class="col row gap-10">
            <p class="col-8 tag tag-12">#tag-12</p><p class="col tag mark tag-12">+ mark</p>
        </div>
    </div>
</main>
